module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.isAddValid),
      callback: function($$v) {
        _vm.isAddValid = $$v
      },
      expression: "isAddValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Status Description:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Status Description",
      "rules": _vm.nameRules,
      "solo": "",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.objRfcStatusEdit.description),
      callback: function($$v) {
        _vm.$set(_vm.objRfcStatusEdit, "description", $$v)
      },
      expression: "objRfcStatusEdit.description"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Triggers Notifications"
    },
    model: {
      value: (_vm.objRfcStatusEdit.triggers_notification),
      callback: function($$v) {
        _vm.$set(_vm.objRfcStatusEdit, "triggers_notification", $$v)
      },
      expression: "objRfcStatusEdit.triggers_notification"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Data Captured"
    },
    model: {
      value: (_vm.objRfcStatusEdit.is_data_captured),
      callback: function($$v) {
        _vm.$set(_vm.objRfcStatusEdit, "is_data_captured", $$v)
      },
      expression: "objRfcStatusEdit.is_data_captured"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Get Approval"
    },
    model: {
      value: (_vm.objRfcStatusEdit.is_get_approval),
      callback: function($$v) {
        _vm.$set(_vm.objRfcStatusEdit, "is_get_approval", $$v)
      },
      expression: "objRfcStatusEdit.is_get_approval"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Approved"
    },
    model: {
      value: (_vm.objRfcStatusEdit.is_accepted),
      callback: function($$v) {
        _vm.$set(_vm.objRfcStatusEdit, "is_accepted", $$v)
      },
      expression: "objRfcStatusEdit.is_accepted"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Denied"
    },
    model: {
      value: (_vm.objRfcStatusEdit.is_cancel),
      callback: function($$v) {
        _vm.$set(_vm.objRfcStatusEdit, "is_cancel", $$v)
      },
      expression: "objRfcStatusEdit.is_cancel"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Reviewed"
    },
    model: {
      value: (_vm.objRfcStatusEdit.is_reviewed),
      callback: function($$v) {
        _vm.$set(_vm.objRfcStatusEdit, "is_reviewed", $$v)
      },
      expression: "objRfcStatusEdit.is_reviewed"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "SR Collection"
    },
    model: {
      value: (_vm.objRfcStatusEdit.is_sr_collection_note),
      callback: function($$v) {
        _vm.$set(_vm.objRfcStatusEdit, "is_sr_collection_note", $$v)
      },
      expression: "objRfcStatusEdit.is_sr_collection_note"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "More Info"
    },
    model: {
      value: (_vm.objRfcStatusEdit.is_more_info),
      callback: function($$v) {
        _vm.$set(_vm.objRfcStatusEdit, "is_more_info", $$v)
      },
      expression: "objRfcStatusEdit.is_more_info"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "SR - Received DDC"
    },
    model: {
      value: (_vm.objRfcStatusEdit.is_received_ddc),
      callback: function($$v) {
        _vm.$set(_vm.objRfcStatusEdit, "is_received_ddc", $$v)
      },
      expression: "objRfcStatusEdit.is_received_ddc"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "SR - Raised"
    },
    model: {
      value: (_vm.objRfcStatusEdit.is_sr_raised),
      callback: function($$v) {
        _vm.$set(_vm.objRfcStatusEdit, "is_sr_raised", $$v)
      },
      expression: "objRfcStatusEdit.is_sr_raised"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "SR - Cancelled"
    },
    model: {
      value: (_vm.objRfcStatusEdit.is_sr_cancelled),
      callback: function($$v) {
        _vm.$set(_vm.objRfcStatusEdit, "is_sr_cancelled", $$v)
      },
      expression: "objRfcStatusEdit.is_sr_cancelled"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "SR - Receipted"
    },
    model: {
      value: (_vm.objRfcStatusEdit.is_sr_receipted),
      callback: function($$v) {
        _vm.$set(_vm.objRfcStatusEdit, "is_sr_receipted", $$v)
      },
      expression: "objRfcStatusEdit.is_sr_receipted"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-2 pt-2 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": !_vm.isAddValid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncUpdateStatus()
      }
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('small', [_vm._v("* The button will activate once all required fields have been completed")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}